import { styled } from '@mui/material'

export const ListItem = styled('li')({
  display: 'block',
  width: '100%',
  paddingLeft: 0,
  paddingRight: 0,
})
